//
//
//
//
//
//
//
//
//
//
//
//
//

import { getWorkOrderOperationLogList } from '../../../../api/workOrder';

export default {
    name: 'operation-log-view',
    props: {
        workOrderId: {
            type: Number, required: true
        }
    },
    data() {
        return {
            list: []
        };
    },
    methods: {
        getWorkOrderOperationLogList() {
            getWorkOrderOperationLogList(this.workOrderId).then(res => {
                this.list = [];
                this.list.push(...res.data.result);
            }).finally(() => {

            });
        }
    },
    created() {
        this.getWorkOrderOperationLogList();
    }
};
